import { isTablet, isMobile } from 'react-device-detect';

export const isMobileOnlyFixed = isMobile && !isTablet;
